var $7af10700b945dced$exports = {};
$7af10700b945dced$exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};


export {$7af10700b945dced$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
